import { Redirect } from 'expo-router';

export default function SupportNativeScreen() {
  return <Redirect href="/" />;
}
